import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoutesConfig} from '@employee-configs/routes.config';
import {NotValidPageComponent} from '@ui-app/pages/not-valid-page/not-valid-page.component';
import * as EmployeeModels from '@employee-models/index';
import {AccessDeniedPageComponent} from '@ui-app/components/access-denied-page/access-denied-page.component';
import {AuthenticationGuard} from './core/guards/authentication.guard';
import {RoleGuard} from './core/guards/role.guard';
import {IndividualRequestPageGuard} from './core/guards/individual-request-page.guard';
import * as SharedModels from '@ui-app/models';
import {AppResolve} from './app.resolve';
import { EmployeeSearchGaurd } from './core/guards/employee-search.gaurd';
import { FindemployeeComponent } from '@employee-pages/employee-search/findemployee/findemployee.component';
import { PhotoComplianceComponent } from '@employee-pages/badge-request-page/photo-compliance/photo-compliance.component';
import { PhotoComplianceRequestComponent } from '@employee-pages/badge-request-page/photo-compliance-request.component';
import { PhotoComplianceRequestPageGuard } from './core/guards/photo-compliance-request.gaurd';
import { ConditionalRedirectGuard } from './core/guards/conditional-redirect.guard';
const routes: Routes = [
    {
        path: '',
        canActivate: [AuthenticationGuard],
        data: {},
        resolve: { configurations: AppResolve },
        children: [
            {
                path: '',
                pathMatch: 'full',
                canActivate: [ConditionalRedirectGuard],
                children: [] // Empty children to satisfy routing requirements
            },
            {
                path: 'cle',
                data: {
                    rolesIds: [
                        // EmployeeModels.DE.UserRoleEnum.CLE,
                        // SharedModels.CE.UserRoleEnum.SecurityUSI
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/cle/cle.module').then(m => m.CleModule)
            },
            {
                path: RoutesConfig.pages.badgeRequests,
                data: {
                    rolesIds: [
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                        SharedModels.CE.UserRoleEnum.SecurityUSI,
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.CsbaUSI,
                        EmployeeModels.DE.UserRoleEnum.FrontDesk,
                        SharedModels.CE.UserRoleEnum.FrontDeskUSI,
                        SharedModels.CE.UserRoleEnum.SeniorManagerUSI,
                        EmployeeModels.DE.UserRoleEnum.ThirdPartyContractorApprover,
                        EmployeeModels.DE.UserRoleEnum.IRCApprover,
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/badge-requests/badge-requests.module').then(m => m.BadgeRequestsModule)
            },
            {
                path: RoutesConfig.pages.photoReview,
                data: {
                    rolesIds: [
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.CsbaUSI,
                        SharedModels.CE.UserRoleEnum.SecurityUSI,
                        SharedModels.CE.UserRoleEnum.SecurityUS
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/photo-review/photo-review.module').then(m => m.PhotoReviewModule)
            },
            {
                path: RoutesConfig.pages.usersManagement,
                data: {
                    rolesIds: [
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                        SharedModels.CE.UserRoleEnum.SecurityUSI,
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/users-management/users-management.module').then(m => m.UsersManagementModule)
            },
            {
                path: RoutesConfig.pages.badgeValidityExtensions,
                data: {
                    rolesIds: [
                        SharedModels.CE.UserRoleEnum.SecurityUSI,           // 61 - Admin USI
                        SharedModels.CE.UserRoleEnum.CsbaUSI,               // 21 - Badging Officer USI
                        SharedModels.CE.UserRoleEnum.SeniorManagerUSI,      // 81 - Senior Manager USI
                        SharedModels.CE.UserRoleEnum.ThirdPartyContractorApprover, // 12 - Third Party Contractor Approver
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/badge-validity-extensions/badge-validity-extensions.module').then(m => m.BadgeValidityExtensionsModule)
            },
              {  path: RoutesConfig.pages.locations,
    data: {
        rolesIds: [
            SharedModels.CE.UserRoleEnum.SecurityUS,
            SharedModels.CE.UserRoleEnum.CsbaUS,
            SharedModels.CE.UserRoleEnum.SecurityUSI
        ]
    },
    canActivate: [RoleGuard],
    loadChildren: () => import('./locations/locations.module').then(m => m.LocationsModule)
},
            {
                path: RoutesConfig.pages.employeeProfile,
                data: {
                    rolesIds: [
                        EmployeeModels.DE.UserRoleEnum.Employee,
                        // FullTimeEmployee && ContractorsOrInterns roles access match Employee
                        EmployeeModels.DE.UserRoleEnum.FTE,
                        EmployeeModels.DE.UserRoleEnum.CLE,
                        // Contractors Or Interns Role
                        EmployeeModels.DE.UserRoleEnum.CTH,
                        EmployeeModels.DE.UserRoleEnum.EchoPartner,
                        SharedModels.CE.UserRoleEnum.EmployeeUS,
                        SharedModels.CE.UserRoleEnum.EmployeeUSI,
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.CsbaUSI,
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                        SharedModels.CE.UserRoleEnum.SecurityUSI,
                        EmployeeModels.DE.UserRoleEnum.FrontDesk,
                        SharedModels.CE.UserRoleEnum.FrontDeskUSI,
                        SharedModels.CE.UserRoleEnum.FacilitatorUSI,
                        SharedModels.CE.UserRoleEnum.SeniorManagerUSI,
                        EmployeeModels.DE.UserRoleEnum.ThirdPartyContractorApprover,
                        EmployeeModels.DE.UserRoleEnum.IRCApprover,
                        EmployeeModels.DE.UserRoleEnum.BusinessApprover,
                        EmployeeModels.DE.UserRoleEnum.TIApprover,
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/employee-profile/employee-profile.module').then(m => m.EmployeeProfileModule)
            },
            {
                path: RoutesConfig.pages.employeeBadgeRequestPage,
                data: {
                    rolesIds: [
                        EmployeeModels.DE.UserRoleEnum.Employee,
                        // FullTimeEmployee && ContractorsOrInterns roles match Employee
                        EmployeeModels.DE.UserRoleEnum.FTE,
                        EmployeeModels.DE.UserRoleEnum.CLE,
                        // Contractors Or Interns Role
                        EmployeeModels.DE.UserRoleEnum.CTH,
                        EmployeeModels.DE.UserRoleEnum.EchoPartner,
                        SharedModels.CE.UserRoleEnum.EmployeeUS,
                        SharedModels.CE.UserRoleEnum.EmployeeUSI,
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.CsbaUSI,
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                        SharedModels.CE.UserRoleEnum.SecurityUSI,
                        EmployeeModels.DE.UserRoleEnum.FrontDesk,
                        SharedModels.CE.UserRoleEnum.FrontDeskUSI,
                        SharedModels.CE.UserRoleEnum.FacilitatorUSI,
                        SharedModels.CE.UserRoleEnum.SeniorManagerUSI,
                        EmployeeModels.DE.UserRoleEnum.ThirdPartyContractorApprover,
                        EmployeeModels.DE.UserRoleEnum.IRCApprover,
                        EmployeeModels.DE.UserRoleEnum.BusinessApprover,
                        EmployeeModels.DE.UserRoleEnum.TIApprover,
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/badge-request-page/employee-badge-request-page.module')
                    .then(m => m.EmployeeBadgeRequestPageModule)
            },
            {
                path: RoutesConfig.pages.individualRequests,
                data: {
                    rolesIds: [
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.CsbaUSI,
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                    ]
                },
                canActivate: [IndividualRequestPageGuard, RoleGuard],
                loadChildren: () => import('./pages/individual-requests/individual-requests.module')
                    .then(m => m.IndividualRequestsModule)
            },
            {
                path: RoutesConfig.pages.bulkProvision,
                data: {
                    rolesIds: [
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.CsbaUSI,
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/bulk-provision/bulk-provision.module')
                    .then(m => m.BulkProvisionModule)
            },
            {
                path: RoutesConfig.pages.manualActions,
                data: {
                    rolesIds: [
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                        SharedModels.CE.UserRoleEnum.SecurityUSI,
                    ],
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/manual-actions/manual-actions.module').then(m => m.ManualActionsModule),
            },
            {
                path: RoutesConfig.pages.PhotoComplianceRequestComponent,
                canActivate:[PhotoComplianceRequestPageGuard],
                component: PhotoComplianceRequestComponent,
            },
            {
                path: RoutesConfig.general.notValidPage,
                component: NotValidPageComponent,
                data: { title: 'Page not valid anymore' }
            },
            {
                path: RoutesConfig.pages.workPermit,
                data: {
                    rolesIds: [
                        SharedModels.CE.UserRoleEnum.SecurityUSI,
                        SharedModels.CE.UserRoleEnum.CsbaUSI,
                        SharedModels.CE.UserRoleEnum.BussinessApprover,
                        SharedModels.CE.UserRoleEnum.TIApprover,
                        SharedModels.CE.UserRoleEnum.ThirdPartyContractorApprover,
                    ]
                },
                canActivate: [RoleGuard],
                loadChildren: () => import('./pages/work-permit/work-permit.module').then(m => m.WorkPermitModule)
            },
            {
                path:RoutesConfig.pages.employeeSearch,
                canActivate:[EmployeeSearchGaurd],
                component:FindemployeeComponent,
            }
        ],

    },

    {
        path: RoutesConfig.general.accessDeniedPage,
        component: AccessDeniedPageComponent,
        data: { title: 'Access denied' }
    },
    {
        path: '**',
        redirectTo: RoutesConfig.general.notValidPage,
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
